export type BasicCourseLayout = 'vertical' | 'grid'

export type DiscoverMatchParams = {
  channel?: string
  topic?: string
}

export const DISCOVER_STATE_FILTERS = [
  'all',
  'not_started',
  'started',
  'completed',
] as const

export const DISCOVER_DURATION_FILTER_VALUES = [
  'under_15',
  '15_30',
  '30_45',
  '60_plus',
] as const

export const DISCOVER_DURATION_FILTERS = [
  'all',
  ...DISCOVER_DURATION_FILTER_VALUES,
] as const

export const DISCOVER_FORMAT_FILTERS = [
  'mp_shorts',
  'mp_originals',
  'pace_courses',
  'text_articles',
] as const

export const DISCOVER_CREATORS = [
  'Masterplan',
  'Big Think',
  'TED',
  'Zeit Akademie',
  'Gianluca Mauro',
  'Holger Wöltje',
  'Ergotopia',
  'Morten Wolff',
  'Harvard Business Review',
] as const

export type DiscoverStateFilter = (typeof DISCOVER_STATE_FILTERS)[number]
export type DiscoverDurationFilterValue =
  (typeof DISCOVER_DURATION_FILTER_VALUES)[number]
export type DiscoverDurationFilter = (typeof DISCOVER_DURATION_FILTERS)[number]
export type DiscoverFormatFilter = (typeof DISCOVER_FORMAT_FILTERS)[number]
export type DiscoverCreator = (typeof DISCOVER_CREATORS)[number]
export type DiscoverCreatorFilter = DiscoverCreator | null

export const ADVANCED_FILTERS_SECTIONS = [
  'state',
  'duration',
  'formats',
] as const

export type AdvancedFiltersSection = (typeof ADVANCED_FILTERS_SECTIONS)[number]

export interface AdvancedFilters {
  channels: string[]
  creator: DiscoverCreatorFilter
  duration: DiscoverDurationFilterValue | null
  formats: DiscoverFormatFilter[]
  query: string
  state: DiscoverStateFilter | null
}

export const DEFAULT_ADVANCED_FILTERS: AdvancedFilters = {
  channels: [],
  creator: null,
  duration: null,
  formats: [],
  query: '',
  state: null,
}
